module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"minWithdraw":"The minimum withdrawal amount is {amount} {symbol}."}}')
  delete Component.options._Ctor
}
